  // Navbar Search Form

  $( '#search-form input' ).on( 'keyup', function( e ) {

    if ( e.key == 'Escape' ) {
      $( '#search-form' ).collapse( 'hide' );
    }

  });

  // $( '#search-form' ).on( 'shown.bs.collapse', function( e ) {

  //   $( 'input', this ).focus();

  // });

  $( '#search-form' ).on( 'show.bs.collapse', function( e ) {

    var $toggle = $( 'button[name="search-toggle"]' );

    $( '.close-search', $toggle ).show();
    $( '.open-search', $toggle ).hide();
    $( '.state', $toggle ).text( 'Hide Search Form' );

  });

  $( '#search-form' ).on( 'hide.bs.collapse', function( e ) {

    var $toggle = $( 'button[name="search-toggle"]' );

    $( '.close-search', $toggle ).hide();
    $( '.open-search', $toggle ).show();
    $( '.state', $toggle ).text( 'Open Search Form' );

  });

$( '#search-form form' ).on( 'submit', function( e ) {

    $( '#searchInput', this ).val( function( i, value ) {

      let newValue = value;

      newValue = newValue.replaceAll( '%', '' )

      if ( newValue == '' ) {
        newValue = "*"
      }

      return newValue

    });

    return e;

});